import { faPalette } from "@fortawesome/pro-solid-svg-icons";
import { styled, useTheme } from "@mui/material/styles";

import { Icon } from "@/components/ui-v2";

import { TileObjectTypeIndicator } from "../common/TileObjectTypeIndicator";
import {
  classes as TileClasses,
  TileBase,
  TileBaseProps,
} from "../TileBase/TileBase";

const StyledTileBase = styled(TileBase)(({ theme }) => ({
  flexDirection: "column",
  gap: theme.spacing(2),
  [`& .${TileClasses.bottomLeftEl}`]: {
    transition: "opacity 0.2s ease-in-out",
    opacity: 0,
  },
  "&:hover": {
    [`& .${TileClasses.bottomLeftEl}`]: {
      opacity: 1,
    },
  },
}));

export const ModelTile = (props: TileBaseProps) => {
  const { slots, slotProps, ...rest } = props;
  const theme = useTheme();

  return (
    <StyledTileBase
      sx={{ background: theme.palette.secondary[6] }}
      slots={{
        ...slots,
        topLeftEl: TileObjectTypeIndicator,
      }}
      slotProps={{
        ...slotProps,
        topLeftEl: {
          objectType: "style",
        },
      }}
      {...rest}
    >
      <Icon icon={faPalette} style={{ width: 64, height: 64 }} />
    </StyledTileBase>
  );
};
